import React, { Component } from 'react'

import { connect } from "react-redux"

import * as appActionCreators from "../actionCreators/app"
import * as authActionCreators from "../actionCreators/auth"
import * as systemParameterActionCreators from "../actionCreators/systemParameter"

import { withRouter } from 'react-router' // need to use withRouter higher order component to access the routing history since the menu isn't a component contained in the current route
import { Link } from 'react-router-dom' //When clicking a <Link>, the URL will be updated and the rendered content will change without reloading the page.

import '../css/menu.css'

import { Sidebar } from 'primereact/components/sidebar/Sidebar'

import { ROLE_ADMIN } from '../js/const'

class Menu extends Component {
  componentDidMount() {
    this.props.setLoading(true)
      .then(() => this.props.getFaqUrl())
      .then(() => this.props.getComplaintsUrl())
      .then(() => this.props.setLoading(false))
      .catch(error => {
        this.props.handleError(error)
          .then(() => this.props.setLoading(false))
      })
  }

  redirect = path => {
    this.props.history.push(path)
    this.props.setLoading(false)
  }

  handleError = error => {
    this.props.handleError(error)
      .then(() => {
        this.props.setLoading(false)
      })
  }

  performLogout = e => {
    e.preventDefault()
    this.props.setLoading(true)
      .then(() => this.props.performLogout())
      .then(() => this.redirect('/'))
      .catch(error => this.handleError(error))
  }

  render() {
    let isAdmin = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_ADMIN)
    let menuItemsMetadata = [
      { path: '/', displayText: 'Home', isVisible: true },
      { path: `/lobbyist/${this.props.auth.lobbyistId}`, displayText: 'My Profile', isVisible: this.props.auth.isAuthenticated === true && isAdmin === false },
      { path: `/change-password/${this.props.auth.lobbyistId}`, displayText: 'Change Password', isVisible: this.props.auth.isAuthenticated === true && isAdmin === false },
      { displayText: 'Logout', isVisible: this.props.auth.isAuthenticated === true && isAdmin === false, onClick: this.performLogout },
      { path: '/login', displayText: 'Login', isVisible: this.props.auth.isAuthenticated === false },
      { path: '/lobbyist/', displayText: 'Register', isVisible: this.props.auth.isAuthenticated === false },
      { path: '/export-annual-return', displayText: 'Search Annual Returns', isVisible: true },
      { path: '/system-parameter', displayText: 'Maintain System Parameters', isVisible: this.props.auth.isAuthenticated === true && isAdmin === true },
      { path: '/audit-log', displayText: 'View Audit Logs', isVisible: this.props.auth.isAuthenticated === true && isAdmin === true },
    ]
    let menuItems = menuItemsMetadata.map(menuItemMetadata => {
      let isActive = menuItemMetadata.path === this.props.location.pathname
      return (
        <React.Fragment key={menuItemMetadata.displayText}>
          {menuItemMetadata.isVisible &&
            <div className={isActive ? 'menu-item active' : 'menu-item'}>
              {menuItemMetadata.path && <Link to={menuItemMetadata.path}>
                <div>{menuItemMetadata.displayText}</div>
              </Link>}
              {menuItemMetadata.onClick && <a onClick={menuItemMetadata.onClick}>{menuItemMetadata.displayText}</a>}
            </div>}
        </React.Fragment>
      )
    })

    return (
      <Sidebar className="menu" visible={this.props.app.isMenuOpen} dismissable={false} showCloseIcon={false}
        onHide={() => this.props.toggleMenu()} style={{ width: '10em' }}>
        {menuItems}
        <div className="menu-item">
          <a href={this.props.systemParameter.faqUrl} target={'_blank'}>Contact</a>
        </div>
        <div className="menu-item">
          <a href={this.props.systemParameter.complaintsUrl} target={'_blank'}>Complaints and disclosures</a>
        </div>
      </Sidebar>
    )
  }
}

const mapStateToProps = ({ app, auth, systemParameter }) => {
  return { app, auth, systemParameter }
}

// this is how to combine actions available
const actionCreators = {
  ...authActionCreators,
  ...appActionCreators,
  ...systemParameterActionCreators
}

export default withRouter(connect(mapStateToProps, actionCreators)(Menu))


// WEBPACK FOOTER //
// ./src/container/Menu.js